export default __webpack_public_path__ + "static/media/careful-water-master.88241b48.png";